import { grantsHref, transactionsHref } from '@/shared/lib/pageLinks'

/**
 * Jurnaldagi ega TURI — agent uchun HAR DOIM `AGENT`.
 *
 * ⚠️ BU TAXMIN EMAS, O'LCHANGAN FAKT. Depozit hisobi bitta joyda
 * ochiladi va u turni QOTIRIB yozadi:
 *
 *   `AccountRef.agentDeposit(...)` -> `money(AGENT_DEPOSIT, OwnerType.AGENT, agentId, currency)`
 *
 * (`xsib-ledger`, `xsib-agent`, `xsib-payments`, `xsib-subscriber` —
 * to'rtala nusxada ham aynan shunday.) `OwnerType.RESELLER` enum'da BOR,
 * lekin uni HECH BIR kod yo'li yozmaydi.
 *
 * Ya'ni RESELLER tugunning yozuvlari ham `owner_type = 'AGENT'` ostida
 * yotadi. Havolaga `RESELLER` yozish — «turi to'g'ri ko'rinadi» degan
 * mulohaza bilan — ro'yxatni BO'SH qaytarardi: server `owner_type` ni
 * ham solishtiradi va hech nima mos kelmasdi. Buzilish esa xato emas,
 * bo'sh jadval bo'lib ko'rinardi.
 */
const JOURNAL_OWNER_TYPE = 'AGENT'

/** «Tranzaksiyalari» — pul jurnali, shu tugun bo'yicha */
export function agentTransactionsHref(agentId: string): string {
  return transactionsHref(JOURNAL_OWNER_TYPE, agentId)
}

/**
 * «Bergan paketlari» — grantlar ro'yxati, `agentId` filtri bilan.
 *
 * ⚠️ Bu ustun `granted_by_agent_id`, ya'ni «shu agent SOTGAN paketlar».
 * «Shu agentning abonentlariga berilgan paketlar» BOSHQA savol va unga
 * javob beradigan filtr grantlar ro'yxatida YO'Q — uni shu havolaga
 * yopishtirish ikki xil sonni bir xil nom bilan ko'rsatardi.
 */
export function agentGrantsHref(agentId: string): string {
  return grantsHref({ agentId })
}
